<template>
  <div class="vms-responsive-list">
    <div class="vms-responsive-list__table">
      <slot name="table"></slot>
    </div>

    <div class="vms-responsive-list__cards">
      <div v-if="loading" class="text-center pa-8">
        <v-progress-circular indeterminate color="info"></v-progress-circular>
        <p class="mt-3 grey--text caption mb-0">{{ loadingText }}</p>
      </div>

      <div v-else-if="!items || !items.length" class="vms-empty">
        <slot name="empty">No items yet</slot>
      </div>

      <div v-else class="vms-card-list">
        <div
          v-for="(item, index) in items"
          :key="resolveKey(item, index)"
          class="vms-list-card"
        >
          <slot name="card" :item="item" :index="index"></slot>
        </div>
      </div>

      <div v-if="showFooter" class="mt-3">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VmsResponsiveList",
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: "Loading…" },
    itemKey: { type: [String, Function], default: "id" },
    showFooter: { type: Boolean, default: false },
  },
  methods: {
    resolveKey(item, index) {
      if (typeof this.itemKey === "function") {
        return this.itemKey(item, index);
      }
      return item?.[this.itemKey] ?? index;
    },
  },
};
</script>
